import { render, staticRenderFns } from "./CwpeProposals.vue?vue&type=template&id=4406958f&"
import script from "./CwpeProposals.vue?vue&type=script&lang=js&"
export * from "./CwpeProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports